// import rootReducer from '../reducers';
// import {createStore, compose} from 'redux';
//
// // enable redux devtools... can this be done with Webpack instead?
// const enhancers = compose(
//   window.devToolsExtension ? window.devToolsExtension() : f => f
// )
//
// export default (initialState) => {
//   return createStore(rootReducer, initialState, enhancers);
// };


import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from '../reducers'

const loggerMiddleware = createLogger()



export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
     ),
     window.devToolsExtension ? window.devToolsExtension() : f => f
   )
  )
}



// WEBPACK FOOTER //
// ./src/store/configure-store.js